import {showEmailConfirmation} from "../EmailConfirmation/showEmailConfirmation";

export const submitListener = () => {
		const formElement = document.querySelector('form') as HTMLFormElement;

		formElement.addEventListener('submit', (e) => {
			e.preventDefault();
			const formData = new FormData(formElement),
			params = new URL(window.location.href).searchParams,
			formParams = new URLSearchParams(formData as any).toString(),
			url = '/vxpay/createUser?' + formParams + '&' + params.toString();
			fetch(url)
				.then(() => {
					showEmailConfirmation();
				})
				.catch((error) => {
					console.error('Error:', error);
				});
			})
		}
